import React from 'react';

function VideoEditorT() {
  return <div></div>;
}

export default VideoEditorT;
